import ThriveLogo from "./Assets/Images/Thrive.jpg";
import BeyondTaxLogo from "./Assets/Images/BeyondTax.png";
import OutskillLogo from "./Assets/Images/Outskill.png";
import InnovyaLogo from "./Assets/Images/Innovya.png";

export let timeline_data = [
  {
    id: "1",
    role: "Software Engineer Intern",
    title: "Thrive Algo (Algo Trading Company)",
    description1:
      "Contributed to backend development and built scalable, high-performance APIs, improving overall system efficiency, and maintaining uptime through optimized microservice orchestration.",
    description2:
      "Revamped company website with the team using Next.js, TypeScript, and Ant Design, resulting in a more responsive and user-friendly interface.",
    description3:
      "Developed and tested low-latency Golang SDKs for multi brokers (Upstox, Fyers, etc.), integrated with execution engine to enable seamless trade flow.",
    techStack: ["Golang", "TypeScript", "AWS", "MongoDB", "NextJs", "Ant Design"],
    buttonText: "View",
    date: "April 2025 - October 2025",
    icon: "work",
    logo: ThriveLogo,
  },
  {
    id: "2",
    role: "Frontend Developer Intern",
    title: "BeyondTax",
    description1:
      "Architected and developed 15+ highly reusable, responsive React components, reducing UI development time by 30% across desktop and mobile formats.",
    description2:
      "Engineered comprehensive RESTful API integrations on the frontend, decoupling business logic from UI layers via custom React hooks, improved data-fetching efficiency by 25%.",
    description3: "",
    techStack: ["React.js", "Tailwind CSS", "Responsive Design"],
    buttonText: "View",
    date: "February 2026 - April 2026",
    icon: "work",
    logo: BeyondTaxLogo,
  },
  {
    id: "3",
    role: "Program Intern",
    title: "Outskill (GrowthSchool)",
    description1:
      "Explored emerging AI technologies and automation techniques for real-world applications.",
description2:
  "Developed an understanding of practical AI applications and opportunities to leverage AI tools to streamline and optimize workflows.",
    description3: "",
    techStack: ["AI Tools", "Workflow Automation", "n8n", "AI Agents"],
    buttonText: "View",
    date: "July 2026 - October 2026",
    icon: "work",
    logo: OutskillLogo,
  },
  {
    id: "4",
    role: "Solution Developer Intern",
    title: "Innovya Technologies",
    description1:
      "Just getting started! 🚀 Will update soon : )",
    description2:
      "",
    description3: "",
    techStack: [],
    buttonText: "View",
    date: "October 2026 - Present",
    active: true,
    icon: "work",
    logo: InnovyaLogo,
  },
];
